
export const SUPER_ADMIN_UIDS = [
  "d99db149-d162-4f07-8930-db89c8a73cd8", // Dawson's user ID
  "ea22cc74-87e0-42ec-97e2-3f1933941c72", // Nicole's user ID
  "292f7e92-85a4-437f-863a-d5c1065a6dc1"  // New super admin UID
];

export const isSuperAdmin = (userId: string | undefined): boolean => {
  return userId ? SUPER_ADMIN_UIDS.includes(userId) : false;
};
